var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},[_c('router-view',{key:_vm.$route.params.id_station || null})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }